<h3 class="with-manual-link">
  <span i18n="@@memory">Gedächtnis</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Insights/Gedächtnis"></app-manual-link>
</h3>
<div class="memory-toggle-wrapper">
  <app-form-for-boolean
    [label]="this.memoryActive"
    [(value)]="this.rss.botConfig.memoryEnabled"
    [colClass]="'col-auto'"
    (valueChange)="this.rss.saveBotConfigField('memoryEnabled')"
  >
    @if (this.rss.botConfig.memoryEnabled) {
    <app-hint i18n="@@memory-enabled-hint">
      Die vom Bot gespeicherten Dialoge können für eine spätere Suche verwendet werden.
    </app-hint>
    }
    @if (!this.rss.botConfig.memoryEnabled) {
    <app-hint i18n="@@memory-disabled-hint">
      Die vom Bot gespeicherten Dialoge werden <b>nicht</b> in einer späteren Suche verwendet.
    </app-hint>
    }
  </app-form-for-boolean>
</div>

<div class="row my-2">
  <div class="col">
    <div class="chat-window">
      <div class="card-header mb-0">
        <div class="row align-items-center g-3 flex-wrap">
          <div class="col">
            <app-bot-memory-browser-filter
              #messageFilter
              [botConfig]="this.rss.botConfig"
            ></app-bot-memory-browser-filter>
          </div>

          <div class="col-auto">
            <p-button
              styleClass="lock-insensitive"
              severity="primary"
              size="small"
              (onClick)="this.openConfirmDeleteHistory(deleteHistoryModal)"
              i18n-label="@@manage-history"
              label="History verwalten"
            ></p-button>
          </div>
        </div>
      </div>

      <div
        #chatScrollContainer
        class="card-body chat-scroll-container"
      >
        <app-bot-chat-dialog
          #myDialog
          id="myDialog"
          [isThinking]="this.isThinking"
          [botConfig]="this.getBotConfig()"
          [enableDeletionOverride]="false"
        ></app-bot-chat-dialog>
      </div>

      <div class="card-footer mb-0">
        <div class="prompt-group">
          <input
            id="promptInput"
            pInputText
            [disabled]="this.isThinking"
            class="prompt lock-insensitive"
            (keyup)="this.onKey($event)"
            [(ngModel)]="this.promptInput"
            placeholder="Frage an das Gedächtnis stellen …"
            i18n-placeholder="@@memory-prompt-placeholder"
          />

          <p-button
            styleClass="send-prompt"
            severity="primary"
            [disabled]="this.isThinking || this.promptInput.trim().length === 0"
            (onClick)="this.add()"
          >
            <i class="ri-send-plane-2-fill"></i>
          </p-button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteHistoryModal>
  <div class="modal-header">
    <h4
      class="modal-title pull-left"
      i18n="@@manage-history-label"
    >
      History verwalten
    </h4>

    <p-button
      [text]="true"
      [rounded]="true"
      icon="pi pi-times"
      (onClick)="this.bsModalRef?.hide()"
      ariaLabel="Close"
    ></p-button>
  </div>

  <div class="modal-body">
    <div class="d-flex align-items-center justify-content-center">
      <app-bot-memory-browser-filter
        #deleteFilter
        [botConfig]="this.getBotConfig()"
        [initialDateRange]="this.messageFilter.selectedDateRange"
      ></app-bot-memory-browser-filter>
    </div>

    <hr>

    <div
      class="text-center"
      i18n="@@delete-history-filter"
    >
      Deine Filterauswahl betrifft <p-tag>{{this.deleteFilter.deleteCount}}</p-tag> History
      Einträge.<br>
      <b>Sollen diese unwiderruflich gelöscht werden?</b>
    </div>
  </div>

  <div class="modal-footer text-end">
    <p-button
      severity="danger"
      (onClick)="this.deleteHistory()"
      i18n-label="@@delete"
      label="Löschen"
    ></p-button>
  </div>
</ng-template>